import {
  NEWDANHMUCSANPHAM_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCSANPHAM_HISTORY_LIST_SUCCESS,
  NEWDANHMUCSANPHAM_IMPORT_SUCCESS,
  NEWDANHMUCSANPHAM_LIST_SUCCESS,
  NEWDANHMUCSANPHAM_NEW_CARE_SUCCESS,
  NEWDANHMUCSANPHAM_ONE_SUCCESS,
  NEWDANHMUCSANPHAM_UPDATE_FILTER,
  NEWDANHMUCSANPHAM_SAVE_SUCCESS,
  NEWDANHMUCSANPHAM_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCSANPHAM_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCSANPHAM_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCSANPHAM_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmucsanpham.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmucsanphamFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmucsanphamPage: 0,
    homepageNewdanhmucsanphamLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmucsanphamItems: [],
  homepageNewdanhmucsanphamTotal: 0,
  homepageNewdanhmucsanphamSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmucsanphamReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCSANPHAM_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCSANPHAM_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCSANPHAM_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCSANPHAM_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmucsanphamFilter !== 'undefined' && state.homepageNewdanhmucsanphamFilter) {
        if (action.data.homepageNewdanhmucsanphamPage == 'no_update' && typeof state.homepageNewdanhmucsanphamFilter.homepageNewdanhmucsanphamPage !== 'undefined') action.data.homepageNewdanhmucsanphamPage = state.homepageNewdanhmucsanphamFilter.homepageNewdanhmucsanphamPage;
        if (action.data.homepageNewdanhmucsanphamLimit == 'no_update' && typeof state.homepageNewdanhmucsanphamFilter.homepageNewdanhmucsanphamLimit !== 'undefined') action.data.homepageNewdanhmucsanphamLimit = state.homepageNewdanhmucsanphamFilter.homepageNewdanhmucsanphamLimit;
      }
      return {
        ...state,
        homepageNewdanhmucsanphamFilter: action.data,
      }
    }
    case NEWDANHMUCSANPHAM_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucsanphamItems: action.data.homepageNewdanhmucsanphamItems,
        homepageNewdanhmucsanphamTotal: action.data.homepageNewdanhmucsanphamTotal,
      }
    }
    case NEWDANHMUCSANPHAM_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucsanphamSelected: action.data
      }
    }
    case NEWDANHMUCSANPHAM_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCSANPHAM_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCSANPHAM_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCSANPHAM_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCSANPHAM_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCSANPHAM_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmucsanphamReducer